import React from 'react';
import { Popover, Button } from 'antd'; 
import { QuestionCircleOutlined } from '@ant-design/icons';
import PropTypes from 'prop-types';

const HelpPopover = ({
  content,
  title,
  placement = 'right',
  iconSize = '16px', 
  iconColor = '#AAA', 
  popoverProps = {},
  iconStyle = {},
  ...restButtonProps 
}) => {
  if (!content) {
    console.warn('HelpPopover: `content` prop is required.');
    return null;
  }

  return (
    <Popover
      content={content}
      title={title}
      trigger="click"
      placement={placement}
      {...popoverProps} 
    >
      
      <Button
        type="text"
        shape="circle"
        icon={<QuestionCircleOutlined style={{ fontSize: iconSize, color: iconColor }} />}
        style={{
          border: 'none',       
          padding: '4px',       
          lineHeight: 2,        
          display: 'inline-flex', 
          alignItems: 'center',
          justifyContent: 'center',
          cursor: 'pointer',    
          ...iconStyle,         
        }}
        aria-label={title || 'More info'} 
        {...restButtonProps} 
      />
    </Popover>
  );
};

HelpPopover.propTypes = {
  content: PropTypes.node.isRequired,
  title: PropTypes.node,
  placement: PropTypes.oneOf([
    'top', 'left', 'right', 'bottom',
    'topLeft', 'topRight', 'bottomLeft', 'bottomRight',
    'leftTop', 'leftBottom', 'rightTop', 'rightBottom',
  ]),
  iconSize: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  iconColor: PropTypes.string,
  popoverProps: PropTypes.object,
  iconStyle: PropTypes.object,
};

export default HelpPopover;